import React from 'react';
import {Tabs,message} from 'antd';
// import StrategyList from './StrategyList';
import StrategyDetails from './StrategyDetail';

const { TabPane } = Tabs;
class StrategyManage extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1",
        params:null,
        isfalse:null,
        flag:null
      }
    }
    callback(activeKey,type,params){
        if(type == "details"){
          this.state.isfalse=true;
          this.state.flag=true;
         this.state.params=params;
        }
        if(type == "add"){
          this.state.isfalse=false;
          this.state.params = null;
          this.state.flag=false;
        }
      this.setState({activeKey:activeKey})
    }
    
    render(){
     
        return(
          <div>
              <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
              {/* <TabPane tab="Box通用策略列表" key="1">
                <StrategyList buttonList={this.props.buttonList} callback = {this.callback.bind(this)}/>
              </TabPane> */}
              <TabPane tab="Box通用策略详情" key="1">
                <StrategyDetails buttonList={this.props.buttonList} isfalse={this.state.isfalse} flag={this.state.flag} params = {this.state.params} callback = {this.callback.bind(this)}/>
              </TabPane>
            </Tabs>
          </div>
        )
    }
}
export default StrategyManage;